'use client';

import React from 'react';

interface Props {
  isActive: boolean;
}

const AudioVisualizer: React.FC<Props> = ({ isActive }) => {
  return (
    <div className="flex items-center justify-center gap-1 h-8">
      {[1, 2, 3, 4, 5].map((bar) => (
        <div
          key={bar}
          className={`w-1.5 bg-brand-500 rounded-full transition-all duration-300 ${
            isActive ? 'animate-sound-wave' : 'h-1.5 opacity-50'
          }`}
          style={{
            animationDelay: `${bar * 0.1}s`,
            height: isActive ? '100%' : '6px'
          }}
        />
      ))}
    </div>
  );
};

export default AudioVisualizer;